export default __webpack_public_path__ + "static/media/IMG_9991.87acd37a.jpeg";